function RevealParallax() {
  const containers = [...document.querySelectorAll('.reveal-parallax')];
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopViewport = window.matchMedia('(min-width: 1024px)');
  const itemSelector = [
    'article',
    'li',
    '[class$="__item"]',
    '[class*="__item "]',
    '[class$="__card"]',
    '[class*="__card "]',
    '[class$="__slide"]',
    '[class*="__slide "]',
  ].join(',');

  if (!containers.length || prefersReducedMotion.matches || !desktopViewport.matches) {
    return;
  }

  const itemState = new Map();
  let ticking = false;
  let animating = false;

  const getItems = (container) => {
    const directItems = [...container.children].filter((item) => item.matches(itemSelector));

    if (directItems.length) {
      return directItems;
    }

    return [...container.querySelectorAll(itemSelector)]
      .filter((item) => item.closest('.reveal-parallax') === container);
  };

  const getOrderedItems = (container) => getItems(container)
    .map((element) => ({
      element,
      rect: element.getBoundingClientRect(),
    }))
    .filter((item) => item.rect.width && item.rect.height)
    .sort((a, b) => {
      if (Math.abs(a.rect.top - b.rect.top) > 12) {
        return a.rect.top - b.rect.top;
      }

      return a.rect.left - b.rect.left;
    });

  const renderItem = (element, y) => {
    element.style.setProperty('--reveal-delay', '0ms');
    element.style.setProperty('--reveal-parallax-y', `${y.toFixed(2)}px`);
    element.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
  };

  const animateItems = () => {
    let shouldContinue = false;

    itemState.forEach((state, element) => {
      state.currentY += (state.targetY - state.currentY) * state.ease;

      if (Math.abs(state.targetY - state.currentY) > 0.1) {
        shouldContinue = true;
      }

      renderItem(element, state.currentY);
    });

    if (shouldContinue) {
      window.requestAnimationFrame(animateItems);
      return;
    }

    animating = false;
  };

  const startAnimation = () => {
    if (animating) {
      return;
    }

    animating = true;
    window.requestAnimationFrame(animateItems);
  };

  const updateTargets = () => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportCenter = viewportHeight / 2;

    containers.forEach((container) => {
      const containerRect = container.getBoundingClientRect();

      if (containerRect.bottom < -viewportHeight * 0.25 || containerRect.top > viewportHeight * 1.25) {
        return;
      }

      const containerCenter = containerRect.top + containerRect.height / 2;
      const distanceFromCenter = containerCenter - viewportCenter;
      const normalizedDistance = Math.max(Math.min(distanceFromCenter / viewportHeight, 1), -1);

      const orderedItems = getOrderedItems(container);
      orderedItems.forEach((item, index) => {
        const staggerOffset = index * 58 * Math.abs(normalizedDistance);
        const offset = normalizedDistance * 130 + staggerOffset;
        const currentState = itemState.get(item.element);
        const ease = Math.max(0.28 - index * 0.075, 0.08);

        itemState.set(item.element, {
          currentY: currentState ? currentState.currentY : offset,
          targetY: offset,
          ease,
        });
      });
    });

    ticking = false;
    startAnimation();
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateTargets);
  };

  updateTargets();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('codelibry:reveal-refresh', requestUpdate);
}

export default RevealParallax;
